const QuestionRepeatType = {
  Never: "Never",
  Immediately: "Immediately",
  After: "After",
};

export default QuestionRepeatType;
